module.exports = __webpack_public_path__ + "assets/img/sf_icon8@2x.c0317ed5.png";